class balanceps extends Tango.Component {
	widgetDidMount() {
		document.querySelector("input[name='date']").addEventListener("change", function (event) {
			let s = event.target;
			let date = Date.parseDate(s.value, '%d.%m.%y');
			let minDate = Date.parseDate(s.getAttribute("data-minDate"), '%d.%m.%y');
			let i = (date - minDate) / 86400000;
			if (i < 0) {
				i = 0;
				s.value = s.getAttribute("data-minDate");
			}
			let maxDate = Date.parseDate(s.getAttribute("data-maxDate"), '%d.%m.%y');
			if (i > (maxDate - minDate) / 86400000) {
				i = (maxDate - minDate) / 86400000;
				s.value = s.getAttribute("data-maxDate");
			}
			document.querySelectorAll('td[data-vals]').forEach(function (td) {
				td.innerHTML = td.getAttribute('data-vals').split(';')[i];
			});
		});
	}
};

Tango.registerComponent(balanceps, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	listview: listview,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));